//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

(function () {
  if (
    typeof WeixinJSBridge == "object" &&
    typeof WeixinJSBridge.invoke == "function"
  ) {
    handleFontSize();
  } else {
    if (document.addEventListener) {
      document.addEventListener("WeixinJSBridgeReady", handleFontSize, false);
    } else if (document.attachEvent) {
      document.attachEvent("WeixinJSBridgeReady", handleFontSize);
      document.attachEvent("onWeixinJSBridgeReady", handleFontSize);
    }
  }
  function handleFontSize () {
    // 设置网页字体为默认大小
    WeixinJSBridge.invoke("setFontSizeCallback", { fontSize: 0 });
    // 重写设置网页字体大小的事件
    WeixinJSBridge.on("menu:setfont", function () {
      WeixinJSBridge.invoke("setFontSizeCallback", { fontSize: 0 });
    });
  }
})();
import mixUmeng from './assets/js/mixUmeng'
import  {selectCdnConf} from './assets/js/api.js'
import settitles from "./views/course/settitle.vue";
export default {
  mixins: [mixUmeng],
  provide(){
    return {
      reload:this.reload
    }
  },
  name: "App",
  components: { settitles},
  data () {
    return {
      isRouterActive:true,
      nolongerShow:false,
      ua: navigator.userAgent.toLowerCase(), //浏览器标识
      docmHeight: "0", //默认屏幕高度
      showHeight: "0", //实时屏幕高度
      isResize: false //默认屏幕高度是否已获取
    };
  },
  mounted () {
    if (/micromessenger/.test(this.ua)) {
      this.$store.state.isWx = true;
    }
    if (/android/.test(this.ua)) {
      if(window.sitename){
        this.copyContentH5(window.sitename)
      }
      this.$store.state.isAndroid = true;
      try {
        setTimeout(() => {
          if(window.location.href.indexOf("channel=gjj")>=0 || window.localStorage.getItem("gjj")){
            window.localStorage.setItem("gjj",1)
          }else{
            window.location.href = 'zj://zj.com'
          }
        }, 2000);
      } catch (error) {
      }
    }
    if (/iphone|ipad|ipod/.test(this.ua)) {
      this.$store.state.isIos = true;
      try {
        setTimeout(() => {
          if(window.location.href.indexOf("channel=gjj")>=0 || window.localStorage.getItem("gjj")){
            window.localStorage.setItem("gjj",1)
          }else{
            window.location.href = 'zj://zj.com'
          }
        }, 2000);
      } catch (error) {
      }
    }
    if(!window.sessionStorage.getItem("cdnConf")){
      selectCdnConf().then(res=>{
        if(res.message.errcode == 200) {
          this.$store.state.cdnConf = res.data
          window.sessionStorage.setItem("cdnConf",JSON.stringify(res.data))
        }
      })
    } else {
      this.$store.state.cdnConf = JSON.parse(window.sessionStorage.getItem("cdnConf"))
    }
    // window.onresize = () => {
    //     if (!this.isResize) {
    //         // 默认屏幕高度
    //         this.docmHeight = document.documentElement.clientHeight;
    //         this.isResize = true;
    //     }
    //     // 实时屏幕高度
    //     this.showHeight = document.body.clientHeight;
    //     if (this.docmHeight < this.showHeight) {
    //         this.$store.state.hidshow = true;
    //     } else if (this.$store.state.isAndroid) {
    //         this.$store.state.hidshow = false;
    //     }
    // };
  },
  methods: {
    closeButton(n) {
      this.$store.state.isShowCouponPopup = false;
      this.$store.state.nanYangGiftCoupon = false;
      if(n==1){
        this.$router.push({
          path:"/my-coupon"
        })
      }
    },
    reload(){
      this.isRouterActive = false;
      this.$nextTick(()=>{
        this.isRouterActive = true;
      })
    },
    closeShowDialogTitle(){
      this.$store.state.showDialogTitle=false;
    },
    closeYunnantixing(){
      if(this.nolongerShow){
        window.localStorage.setItem("isYunnanPopUp",'true')
      } else {
        window.sessionStorage.setItem("isYunnanPopUp",'true')
      }
      this.$store.state.isShowYunnanZJ = false;
    },
    copyContentH5(content) {
        var copyDom = document.createElement('div');
        copyDom.innerText=content;
        copyDom.style.position='absolute';
        copyDom.style.top='0px';
        copyDom.style.right='-9999px';
        document.body.appendChild(copyDom);
        //创建选中范围
        var range = document.createRange();
        range.selectNode(copyDom);
        //移除剪切板中内容
        window.getSelection().removeAllRanges();
        //添加新的内容到剪切板
        window.getSelection().addRange(range);
        //复制
        var successful = document.execCommand('copy');
        copyDom.parentNode.removeChild(copyDom);
        try{
            var msg = successful ? "successful" : "failed";
            console.log('Copy command was : ' + msg);
        } catch(err){
            console.log('Oops , unable to copy!');
        }
    },
    edithandel(){
      this.$router.push({
          path: "/enitPassWord"
        });
        this.$store.state.dialogPassworldIsShow=false;

    },
    cancelHandel(){
      this.$store.state.dialogPassworldIsShow=false;
    },
    handleClose(){
       this.$store.state.dialogPassworldIsShow=false;

    }
    // //所有获取焦点事件
    // focusinFn() {
    //     //安卓虚拟键盘影响屏幕可视高度，ios没有
    //     if (this.$store.state.isAndroid) {
    //         this.$store.state.hidshow = false;
    //     }
    // },
    // // 所有失去焦点事件
    // focusoutFn() {
    //     this.$store.state.hidshow = true;
    // }
  }
};



// WEBPACK FOOTER //
// ./src/App.vue